import React, { useState, useEffect } from 'react';
import '../../Assets/Css/AttendanceSummery.scss';
import '../../Assets/Css/AttendanceByHour.scss';
import Absent from "../../Assets/Images/Attendance/absent.svg"
import Calander from "../../Assets/Images/Attendance/calander.svg"
import Holiday from "../../Assets/Images/Attendance/Holiday.svg"
import Late from "../../Assets/Images/Attendance/late.svg"
import RightArrow from "../../Assets/Images/Attendance/Right Arrow.svg"
import Leave from "../../Assets/Images/Attendance/leave.svg"
import Halfday from "../../Assets/Images/Attendance/half-day.svg"
import { Link, useLocation } from 'react-router-dom';

const AttendanceByHour = () => {
    const [daysInMonth, setDaysInMonth] = useState([]);
    const [employeeData, setEmployeeData] = useState([
        {
            name: "Raj Viradiya",
            role: "Developer",
            avatar: "https://example.com/avatar.jpg",
            attendance: {
                2023: {
                    8: [
                        { day: 'Tue', status: 'p', hours: 8 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'hod', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'p', hours: 8 },
                        { day: 'Tue', status: 'la', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'p', hours: 8 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                    ],
                    9: [
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'p', hours: 8 },
                        { day: 'Tue', status: 'la', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'hod', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'ol', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 }
                    ]
                },
                2024: {
                    9: [
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'p', hours: 8 },
                        { day: 'Tue', status: 'la', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'hod', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'ol', hours: 0 },
                        { day: 'Tue', status: 'p', hours: 8 },
                        { day: 'Wed', status: 'la', hours: 0 },
                        { day: 'Thu', status: 'p', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                        { day: 'Tue', status: 'a', hours: 0 },
                        { day: 'Wed', status: 'p', hours: 8 },
                        { day: 'Thu', status: 'hod', hours: 8 },
                        { day: 'Fri', status: 'p', hours: 8 },
                        { day: 'Sat', status: 'hd', hours: 4 },
                        { day: 'Sun', status: 'Sun', hours: 0 },
                        { day: 'Mon', status: 'la', hours: 0 },
                    ]
                }
            }
        }
    ]);
    
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();

    const calculateDaysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    useEffect(() => {
        const days = calculateDaysInMonth(month, year);
        const daysArray = Array.from({ length: days }, (_, index) => {
            const date = new Date(year, month - 1, index + 1);
            return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
        });
        setDaysInMonth(daysArray);
    }, [month, year]);

    return (
        <div className="attendance-table">
            <div className="suggestion">
                <h6 className='m-0 me-2 '>Note :</h6>
                <div className='suggestion_comp'>
                    <img src={Holiday} className='svg' />
                    <img src={RightArrow} className='svgarrow' />
                    Holiday
                </div>
                <div className='suggestion_comp'>
                    <img src={Absent} className='svg' />
                    <img src={RightArrow} className='svgarrow' />
                    Absent
                </div>
            </div>

            <div className='table_cont'>
                <table>
                    <thead>
                        <tr>
                            <th className='firsttablehead'>Employee</th>
                            {daysInMonth.map((item, idx) => (
                                <th key={idx} className=''>{item.day}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employeeData?.map((employee, idx) => {
                            const attendanceForMonth = employee.attendance[year]?.[month] || [];
                            return (
                                <tr key={idx}>
                                    <td className="employee-info">
                                        <img src={employee.avatar} alt={employee.name} />
                                        <div className='employee-info-details'>
                                            <span>{employee.name}</span>
                                            <span className="role">{employee.role}</span>
                                        </div>
                                    </td>
                                    {/* {daysInMonth.map((item, idx) => (
                                        <td key={idx} className="attendance-status">
                                            {((attendanceForMonth[item.day - 1] == "Sun") && <img src={Holiday} className='svg_table' />) ||
                                                ((attendanceForMonth[item.day - 1] == "hod") && <img src={Holiday} className='svg_table' />) ||
                                                ((attendanceForMonth[item.day - 1] == "hd") && <img src={Halfday} className='svg_table' />) ||
                                                ((attendanceForMonth[item.day - 1] == "la") && <img src={Late} className='svg_table' />) ||
                                                ((attendanceForMonth[item.day - 1] == "p") && <img src={Calander} className='svg_table' />) ||
                                                ((attendanceForMonth[item.day - 1] == "ol") && <img src={Leave} className='svg_table' />) ||
                                                ((attendanceForMonth[item.day - 1] == "a") && <img src={Absent} className='svg_table' />) ||
                                                (attendanceForMonth[item.day - 1]) || "-"
                                            }
                                        </td>
                                    ))} */}
                                    {attendanceForMonth.map((item, idx) => (
                                        <td key={idx}>
                                            <Link to='/attendance/details' className="attendance-link">
                                                {((item.status == "Sun") && <img src={Holiday} className='svg_table' />) ||
                                                    ((item.status == "Hod") && <img src={Holiday} className='svg_table' />) ||
                                                    ((item.status == "ol") && <img src={Leave} className='svg_table' />) ||
                                                    (item.hours !== 0 ? item.hours : <img src={Leave} className='svg_table' />) || "-"
                                                }
                                            </Link>
                                        </td>
                                    ))}
                                    <td className="total">
                                        {attendanceForMonth.reduce((acc, curr) => acc + curr.hours, 0)} hours
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AttendanceByHour;
